(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floraanimation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ely-floral-entry')){
customElements.define('ely-floral-entry',class extends HTMLElement{
connectedCallback(){
 if(this.started)return;this.started=true;
 if(matchMedia('(prefers-reduced-motion: reduce)').matches){this.hidden=true;return;}
 const mobile=matchMedia('(max-width:749px)').matches;
 const count=Number(mobile?this.dataset.mobileCount:this.dataset.count);
 const duration=Number(this.dataset.duration)*1000;
 const holder=this.querySelector('.floral-entry__petals');
 const colors=(this.dataset.petalColors || '#E9D9BD,#D4B98D,#F5EADB,#B69A74').split(',');
 for(let i=0;i<count;i++){
  const p=document.createElement('span');p.className='floral-entry__petal';
  // Keep the offer and central bottle area visually clear.
  const left=i%2===0?Math.random()*20:80+Math.random()*20;
  p.style.backgroundColor=colors[i % colors.length];
  p.style.left=left+'%';p.style.setProperty('--drift',(Math.random()*100-50)+'px');
  p.style.setProperty('--spin',(Math.random()*360+90)+'deg');
  p.style.setProperty('--fall',(5+Math.random()*3)+'s');
  p.style.setProperty('--delay',(Math.random()*Math.max(0,(duration/1000)-8))+'s');
  holder.appendChild(p);
 }
 this.finishTimer=setTimeout(()=>this.setAttribute('data-finished',''),duration);
 this.cleanTimer=setTimeout(()=>{holder.replaceChildren();this.hidden=true;},duration+1400);
}
disconnectedCallback(){clearTimeout(this.finishTimer);clearTimeout(this.cleanTimer);}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-notes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ely-notes-filter')) {
  customElements.define('ely-notes-filter', class extends HTMLElement {
    connectedCallback() {
      this.life = new AbortController();
      this.sequence = 0;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-note-tags], [data-note-clear], [data-note-remove]');
        if (!button || !this.contains(button) || button.disabled) return;
        event.preventDefault();
        this.filter(button.dataset.noteTags || button.dataset.noteRemove || '');
      }, { signal: this.life.signal });
      // A full restore on browser history also resets Horizon's pagination state.
      window.addEventListener('popstate', () => {
        this.sequence++;
        this.pending?.abort();
        window.location.reload();
      }, { signal: this.life.signal });
      // Horizon updates its own filters with AJAX. Reflect those changes here.
      this.observer = new MutationObserver(() => {
        if (!this.busy) this.sync();
      });
      const main = this.closest('main') || document.querySelector('main');
      if (main) this.observer.observe(main, { childList: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.life?.abort();
      this.pending?.abort();
      this.observer?.disconnect();
      this.unlock();
    }
    tags(url) {
      return url.searchParams.getAll('filter.p.tag').flatMap(value => value.split(',')).map(tag => this.canonical(tag)).filter(Boolean);
    }
    canonical(tag) {
      const clean = tag.trim();
      if (!this.tagMap) {
        let values = [];
        try { values = JSON.parse(this.querySelector('[data-note-canonical-tags]')?.textContent || '[]'); } catch (_) {}
        this.tagMap = new Map(values.map(value => [value.toLowerCase(), value]));
      }
      return this.tagMap.get(clean.toLowerCase()) || clean;
    }
    group(button) {
      return (button.dataset.noteTags || '').split(',').map(tag => this.canonical(tag)).filter(Boolean);
    }
    sync() {
      const selected = this.tags(new URL(this.desiredURL || window.location.href));
      let any = false;
      this.querySelectorAll('[data-note-tags]').forEach(button => {
        const group = this.group(button);
        const active = group.length > 0 && group.some(tag => selected.includes(tag));
        any ||= active;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const clear = this.querySelector('[data-note-clear]');
      if (clear) clear.hidden = !any;
      const signature = JSON.stringify(selected);
      if (this.chipSignature !== signature) {
        this.chipSignature = signature;
        const chips = this.querySelector('.eln__chips');
        const fragment = document.createDocumentFragment();
        this.querySelectorAll('[data-note-tags]').forEach(card => {
          const groupValue = card.dataset.noteTags;
          if (!this.group(card).some(tag => selected.includes(tag))) return;
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'eln__chip';
          chip.dataset.noteRemove = groupValue;
          const label = card.querySelector('.eln__label').textContent.trim();
          chip.textContent = label + ' ×';
          chip.setAttribute('aria-label', 'Remove ' + label + ' filter');
          fragment.append(chip);
        });
        chips?.replaceChildren(fragment);
      }
    }
    targetURL(groupValue) {
      const url = new URL(this.desiredURL || window.location.href);
      const managed = new Set(Array.from(this.querySelectorAll('[data-note-tags]')).flatMap(button => this.group(button)));
      const clicked = groupValue.split(',').map(tag => this.canonical(tag)).filter(Boolean);
      const selected = this.tags(url);
      const clickedIsActive = clicked.some(tag => selected.includes(tag));
      let keep = selected.filter(value => {
        if (!groupValue) return !managed.has(value);
        if (clicked.includes(value)) return false;
        if (this.dataset.multiple !== 'true' && managed.has(value)) return false;
        return true;
      });
      if (groupValue && !clickedIsActive) keep.push(...clicked);
      url.searchParams.delete('filter.p.tag');
      [...new Set(keep)].forEach(value => url.searchParams.append('filter.p.tag', value));
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.hash = '';
      return url;
    }
    grid() {
      return Array.from(document.querySelectorAll('results-list[section-id]')).find(node => node.closest('collection-component'));
    }
    unlock() {
      if (this.locked) {
        this.locked.inert = this.wasInert;
        this.locked.removeAttribute('aria-busy');
        this.locked = null;
      }
    }
    async filter(tag) {
      if (this.dataset.enabled !== 'true') return;
      const url = this.targetURL(tag);
      this.desiredURL = url.href;
      this.sync();
      const results = this.grid();
      const wrapper = results?.closest('[id^="shopify-section-"]');
      const sectionId = results?.getAttribute('section-id');
      if (!wrapper || !sectionId) { window.location.assign(url.href); return; }
      this.pending?.abort();
      this.unlock();
      const sequence = ++this.sequence;
      const controller = new AbortController();
      this.pending = controller;
      this.busy = true;
      this.locked = wrapper;
      this.wasInert = wrapper.inert;
      wrapper.inert = true;
      wrapper.setAttribute('aria-busy', 'true');
      const status = this.querySelector('.eln__status');
      status.textContent = 'Updating products…';
      const fetchURL = new URL(url);
      fetchURL.searchParams.set('section_id', sectionId);
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(fetchURL, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Section request failed');
        const html = await response.text();
        if (sequence !== this.sequence || !this.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.getElementById(wrapper.id);
        const newResults = replacement?.querySelector('results-list');
        if (!newResults || newResults.getAttribute('section-id') !== sectionId) throw new Error('Missing collection results');
        // Fresh custom elements reset infinite scroll and reconnect Horizon controls.
        // Update URL before connecting them so future requests use the active tag.
        history.pushState({ ...history.state }, '', url.href);
        wrapper.replaceChildren(...Array.from(replacement.childNodes));
        this.desiredURL = null;
        this.sync();
        status.textContent = 'Products updated.';
      } catch (error) {
        if (sequence !== this.sequence || !this.isConnected) return;
        // A timed-out or failed request still has a working native-filter fallback.
        window.location.assign(url.href);
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) {
          this.busy = false;
          this.unlock();
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
